import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {GoogleComponent} from "@pages/utils/google.component";
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { ManutencaoEnderecoComponent } from './manutencao-endereco/manutencao-endereco.component';
import { ManutencaoProdutoComponent } from './manutencao-produto/manutencao-produto.component';
import { FooterComponent } from '../../components/footer/footer.component';

@Component({
    selector: 'app-painel-manutencoes',
    templateUrl: './painel-manutencoes.component.html',
    styleUrls: ['./painel-manutencoes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, BreadcrumbComponent, ManutencaoEnderecoComponent, ManutencaoProdutoComponent, FooterComponent]
})
export class PainelManutencoesComponent extends GoogleComponent implements OnInit {

  ngOnInit(): void {
    this.addTagManagerScreenView(null, null, null);
  }

  goBackPage(sectionApp: string, screenName: string, screenType: string) {
    this.addTagManagerInteraction('select:icon:click', 'voltar', sectionApp, screenName, screenType);
    window.history.back();
  }

}
